import { backButton } from "@tma.js/sdk-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export interface BackButtonProps {
  onClick?: () => void;
  disabled?: boolean;
}

export default function BackButton({ onClick, disabled }: BackButtonProps = {}) {
  const navigate = useNavigate();
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  useEffect(() => {
    if (disabled) {
      backButton.hide();
      return;
    }

    const navBack = () => {
      if (onClickRef.current) {
        onClickRef.current();
      } else if (window.history.state?.idx > 0) {
        navigate(-1);
      } else {
        navigate("/");
      }
    };

    backButton.show();
    backButton.offClick(navBack);
    backButton.onClick(navBack);

    return () => {
      backButton.offClick(navBack);
      backButton.hide();
    };
  }, [navigate, disabled]);

  return null;
}
